import React, { useEffect, useState } from "react"
import s from "./Experience.module.scss"
import cx from "classnames"

import ExperienceLoader from "scripts/loaders/ExperienceLoader"
import ARLoader from "scripts/loaders/ARLoader"
import EventBus from "scripts/util/EventBus"
import MainLayout from "layouts/Main"

import CloseIcon from "assets/images/dogmented/close.svg"

import PlaceUI from "components/UI/PlaceUI"
import MainUI from "components/UI/MainUI"
import Loading from "components/Loading"
import TagManager from "react-gtm-module"


const Experience = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [view, setView] = useState("")
  const [showToys, setShowToys] = useState("hide")
  const [modals, setModals] = useState([])
  const [unlockedTricks, setUnlockedTricks] = useState([])
  const [lockMenu, setlockMenu] = useState(false)
  const [tooClose, setTooClose] = useState(false)
  const [showArrowAnimation, setShowArrowAnimation] = useState(false);
  const [tutorialStepState, setTutorialStepState] = useState(process.env.NODE_ENV === 'development' ? 0 : parseInt(localStorage.getItem("tutorialStep")) || 0);

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        pagePath: '/experience',
        pageTitle: 'Experience',
      },
    });
    EventBus.on("Action", handleAction)

    window.addEventListener('visibilitychange', () => {
      document.visibilityState === 'visible' ? window.location.reload() : window.XR8.stop()
    }) 
    window.addEventListener("mediarecorder-previewclosed", handlePreviewClosed)
    window.addEventListener("mediarecorder-previewopened", handlePreviewOpened)

    ARLoader.load().then(() => {
      ExperienceLoader.load("Main").then(onLoadModule)
    })

    return () => {
      window.removeEventListener(
        "mediarecorder-previewclosed",
        handlePreviewClosed
      )
      window.removeEventListener(
        "mediarecorder-previewopened",
        handlePreviewOpened   
      )
    }
  }, []) // eslint-disable-line

  useEffect(() => {
    const s = new Set(unlockedTricks)
    if (unlockedTricks.length !== s.size) {
      setUnlockedTricks(() => Array.from(s))
    }
  }, [setUnlockedTricks, unlockedTricks]) 

  useEffect(() => {
    if (view === 'photo') {
      const iframe = document.getElementById('iframePhotoSave')
      iframe.style.opacity = '0'
      document.getElementById('iframePhotoSave').src = document.getElementById('iframePhotoSave').src
      setTimeout(() => {iframe.style.opacity = '1';}, 500);
    }
  }, [view])


  const onLoadModule = (module) => {
    const experience = new module.default()
    const canvas = document.getElementById("ar-canvas")
    const hitArea = document.getElementById("hitArea")

    experience.initPipeline(
      canvas,
      hitArea,
      tutorialStepState
    )
    experience.load().then(() => {
      experience.initExperience()
    })
  }

  const handleAction = (payload) => {
    console.log("Event:", payload)
    if (payload.type === "loadingDone") {
      setLoading(false)
      setView("place")
    }
    if (payload.type === "place") {
      setView("main")
    }
    if (payload.type === "cameraFlipStart") {
      ARLoader.flipCamera()
      setTimeout(() => {
        EventBus.dispatch("Action", { type: "cameraFlipComplete" })
      }, 1000)
    }
    if (payload.type === "showToys") {
      setShowToys("show")
    }
    if (payload.type === "hideToys") {
      setShowToys("hide")
    }
    if (payload.type === "disabledToys") {
      setShowToys("disabled")
    }
    if (payload.type === "modal") {
      if (payload.name === "closeAll") {
        setModals(() => [])
        setlockMenu(false)
      } else if(payload.name === 'distanceBad') {
        setTooClose(true)
      } else if(payload.name === 'distanceGood') {
        setTooClose(false)
      } 
      else if(payload.name === 'showArrows') {
        setShowArrowAnimation(true)
      } else if(payload.name === 'hideArrows') {
        setShowArrowAnimation(false)
      } else {
        setModals(() => [payload.name])
        setlockMenu(true)
      }
    }
    if (payload.type === "unlockTrick") {
      setUnlockedTricksHelper(payload.number)
    }
    if (payload.type === "tutorialStep") {
      setTutorialStep(payload.num)
    }
  }

  const setUnlockedTricksHelper = (number) => {
    switch (number) {
      case 0: setUnlockedTricks((arr) => [...arr, "trickSitPretty"]); break;
      case 1: setUnlockedTricks((arr) => [...arr, "trickBackflip"]); break;
      case 2: setUnlockedTricks((arr) => [...arr, "trickSpin"]); break;
      case 3: setUnlockedTricks((arr) => [...arr, "trickSpeak"]); break;
      case 4: setUnlockedTricks((arr) => [...arr, "tryPet"]); break;
      default: break;
    }
  }

  
  useEffect(() => {
    const tutorialInitialization = (step) => {
      let arr = []
      const stepMap = {
        1: [4],
        5: [4, 0],  
        6: [4, 0, 1],  
        7: [4, 0, 1, 2],  
        8: [4, 0, 1, 2, 3], 
      }
      arr = stepMap[step] || []
      if (step > 8) {
        arr = [4, 0, 1, 2, 3]
      }
      arr.forEach(num => setUnlockedTricksHelper(num))
    }
    tutorialInitialization(tutorialStepState)
    
    EventBus.dispatch("Action", {
      type: "tutorialStep",
      num: tutorialStepState,
    })

    
  }, [tutorialStepState])

  const setTutorialStep = (num) => {
    setTutorialStepState(num)
    localStorage.setItem("tutorialStep", num)
  }

  const handlePreviewClosed = () => {
    setView("main")
  }
  const handlePreviewOpened = () => {
    setView("photo")
    setModals((old) => old.filter((name) => name !== "snapAndShare"))
    setlockMenu(false)
  }

  return (
    <MainLayout>
      <div className={cx(s.Experience, s.hasBackground)}>
        {!loading && view !== "photo" && (
          <a className={s.close} href="/play-again">
            <img src={CloseIcon} alt="Close" />
          </a>
        )}
        {loading && <Loading />}
        {tooClose && <div className={s.tooClose}>
          <h4>Too close to dog, please move back.</h4>  
        </div>}
        <div className={s.hitArea} id="hitArea" />
        {!loading && view === "place" && <PlaceUI />}
        {!loading && view === "main" && (
          <MainUI
            showToys={showToys}
            modals={modals}
            setModals={setModals}
            setUnlockedTricks={setUnlockedTricks}
            unlockedTricks={unlockedTricks}
            lockMenu={lockMenu}
            setlockMenu={setlockMenu}
            view={view}
            showArrowAnimation={showArrowAnimation}
            tutorialStepState={tutorialStepState}
          />
        )}
      </div>
    </MainLayout>
  )
}

export default Experience
